import ChannelIcon from '@mui/icons-material/Cable';
import ChannelList from './ChannelList';

export default {
    list: ChannelList,
    icon: ChannelIcon,
    recordRepresentation: (record: any) =>
        `${record?.distributor_id} - ${record.id}`,
};
